import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getRescueSelector } from '../selectors'
import { RescueConstants } from '../store/rescue.constants'
import { IRescueState } from '../store/rescue.types'

export function* setActivations() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const rescueState: IRescueState = yield select(getRescueSelector)
  const { inputRows } = procedureState
  const { activations } = rescueState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === RescueConstants.SET_ACTIVATIONS) {
        //@ts-ignore
        input.props.savedValues = activations
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setActivationsSaga() {
  yield takeLatest([RescueConstants.SET_ACTIVATIONS], setActivations)
}
